import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import HeaderSheet from '../common/HeaderSheet';
import ChordBarsLevels from './ChordBarsLevels';

import './ChordBarsMixer.scss';

/**
 * The preview's levels in a sheet off the dialog's header, so they don't lengthen the body. Pairs
 * with ChordBarsTransport, and like it holds no state. See ChordBarsLevels for what it shows.
 */
const ChordBarsMixer = ({ isOpen, onClose, player, idPrefix, instrumentIcon, drums = false }) => {
  const { t } = useTranslation();

  return (
    <HeaderSheet isOpen={isOpen} onClose={onClose} label={t('player.volume')} className="ChordBarsMixer">
      <ChordBarsLevels player={player} idPrefix={idPrefix} instrumentIcon={instrumentIcon} drums={drums} />
    </HeaderSheet>
  );
};

ChordBarsMixer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  player: PropTypes.object.isRequired,
  idPrefix: PropTypes.string,
  instrumentIcon: PropTypes.node,
  drums: PropTypes.bool,
};

export default ChordBarsMixer;
